import React from 'react';

function CompanySettings() {
  return (
    <div className="container">
      <p>Company settings</p>
    </div>
  );
}

export default CompanySettings;